import { IStore } from 'store/configureStore';

export const selectNotifications = (state: IStore) => Object.values(state.modules.notificationCenter.notificationsById);
export const selectHasNewNotifications = (state: IStore) =>
    // @ts-ignore
    selectNotifications(state).find(notification => !notification.viewed);
